import React from "react";

import cn from "classnames";

import { Box, boxForwardRef } from "../../../../../helpers";
import { useTextChildProps } from "../../../../../helpers/common/TextCore/helpers/useTextChildProps";
import { createDisplayNameForTextElement } from "../../utils/getDisplayName";

import type { BoxComponentWithDefault } from "../../../../../helpers";
import type { TextCoreChildProps } from "../../../../../helpers/common/TextCore/types";
import type {
    PropsWithTsId,
    PropsWithViewNever,
} from "../../../../../types/react";
import type { TextLinkBaseViews } from "../../../TextLink/types";

import linkClasses from "./TextLink.styl";

type TextTextLinkProps = PropsWithTsId<
    PropsWithViewNever<TextCoreChildProps, TextLinkBaseViews>
>;

export type PolymorphicTextTextLinkProps = BoxComponentWithDefault<
    "a",
    TextTextLinkProps,
    "style" | "className"
>;

export const TextLink = boxForwardRef<PolymorphicTextTextLinkProps>(
    ({
        as = "a",
        view = "primary",
        customColorsStyles,
        children,
        "data-tsid": tsid,
        ...props
    }) => {
        const { className, style, filteredProps } = useTextChildProps(
            props,
            cn(
                linkClasses["text-link"],
                view !== "primary" && linkClasses[`__view-${view}`],
                customColorsStyles,
            ),
        );

        return (
            <Box
                as={as}
                data-tsid={tsid}
                className={className}
                style={style}
                {...filteredProps}
            >
                {children}
            </Box>
        );
    },
);

TextLink.displayName = createDisplayNameForTextElement("Link");
